module.exports = __webpack_public_path__ + "img/flipcard-default-front.7bb6bc0e.png";